import { useState, useEffect, useCallback } from 'react';

export const useCarousel = (length: number, interval: number) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const goTo = useCallback(
    (index: number) => {
      if (index !== activeIndex && index < length) {
        setActiveIndex(index);
      }
    },
    [activeIndex, length],
  );

  useEffect(() => {
    if (length <= 1) return undefined;
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % length);
    }, interval);
    return () => clearInterval(timer);
  }, [length, interval]);

  useEffect(() => {
    if (activeIndex >= length && length > 0) {
      setActiveIndex(0);
    }
  }, [activeIndex, length]);

  return { activeIndex, goTo };
};
